import apiSlice from "./apiSlice";


const keyDprPMSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllDprPM: builder.query({
            query: (req) => ({
                url: `pnmdata`,
                params: req,
            }),
        }),
        getPendingDprPM: builder.query({
            query: (req) => ({
                url: `pnmdata/GetWorkFlows`,
                params: req,
            }),
        }),
        editDprPmList: builder.mutation({
            query: (data)=> ({
                url: `pnmdata/update-actual`,   
                method: "PUT",
                body: data
            })
        }),
        getPMDataDetail: builder.query({
            query: (req) => ({
              url: `pnmdata/${req}`
            }),
          }),
          updateWorkFlowPMData: builder.mutation({
            query: (body) => ({
              url: `pnmdata/UpdateWorkflow`,
              method: "POST",
              body,
            }),
          }),


           editQuantityList: builder.query({
            query: (req) => ({
                url: `schedule/dpr-data`,
                params: req,
            }),
        }),

    }),
});

export const { useGetAllDprPMQuery,
     useEditDprPmListMutation,
     useGetPMDataDetailQuery,
     useUpdateWorkFlowPMDataMutation,
     useGetPendingDprPMQuery,
     useEditQuantityListQuery
    
    } = keyDprPMSlice;